import { URL } from 'api/constants';
import { apiInstance } from 'api/instance';

export const activationStatus = (id: any) =>
  apiInstance.get(`${URL.ACTIVATION_STATUS}/${id}`);
